import { render, staticRenderFns } from "./ProviderClassificationInfo.vue?vue&type=template&id=783b08d4"
import script from "./ProviderClassificationInfo.vue?vue&type=script&lang=js"
export * from "./ProviderClassificationInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports